import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'un-action-list',
  templateUrl: './action-list.component.html',
  styleUrls: ['./action-list.component.less'],
  standalone: false,
})
export class ActionListComponent {
  @Input() viewLink: string[];
  @Input() viewLinkQuery?: Params;
  @Input() editLink?: string[];
  @Input() hideView?: boolean;
  @Input() hideEdit?: boolean;
  @Input() hideDelete?: boolean;
  @Input() hideNotes?: boolean;
  @Input() hideAssign?: boolean;
  @Input() notesCount?: number;
  @Output() view = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  @Output() assign = new EventEmitter<void>();
  @Output() openNotes = new EventEmitter<void>();

  constructor(public elementRef: ElementRef) {}

  @HostListener('click', ['$event'])
  click($e: PointerEvent) {
    $e.stopPropagation();
    $e.cancelBubble = true;
    return false;
  }
}
